import type { LogOverviewRow } from '@/api/hooks/useIntegrationLogs'

export const MAX_BULK_RETRY_ORDERS = 200

export function eligibleOrderRows(rows: LogOverviewRow[]): LogOverviewRow[] {
  return rows.filter((row) => row.metadata.type === 'order')
}
